// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring {
    background-color: #ebf3f8;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  
  .monitoring .div {
    background-color: #ebf3f8;
    border: 1px none;
    height: 1080px;
    overflow: hidden;
    position: relative;
    width: 1920px;
  }
  
  .monitoring .overlap {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #d9d9d9;
    height: 102px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 1922px;
  }
  
  .monitoring .header-DATA {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 144px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .monitoring .logo-SIVINA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    height: 60px;
    left: 64px;
    position: absolute;
    top: 20px;
    width: 60px;
  }
  
  .monitoring .action-project {
    color: #000000;
    font-family: "Montserrat-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 1329px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .monitoring .action-dashboard {
    color: #000000;
    font-family: "Montserrat-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 1650px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .monitoring .profile-icon {
    background-color: #49bc92;
    border-radius: 25px;
    height: 50px;
    left: 1840px;
    position: absolute;
    top: 25px;
    width: 50px;
  }
  
  .monitoring .s {
    height: 18px;
    left: 19px;
    position: absolute;
    top: 16px;
    width: 13px;
  }
  
  .monitoring .action-filter-store {
    height: 40px;
    left: 64px;
    position: absolute;
    top: 118px;
    width: 402px;
  }
  
  .monitoring .overlap-group {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 400px;
  }
  
  .monitoring .polygon {
    height: 13px;
    left: 369px;
    position: absolute;
    top: 10px;
    width: 15px;
  }
  
  .monitoring .MSRA {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper {
    letter-spacing: 0;
  }
  
  .monitoring .span {
    letter-spacing: 0.4px;
  }
  
  .monitoring .action-filter-lain {
    height: 40px;
    left: 494px;
    position: absolute;
    top: 118px;
    width: 402px;
  }
  
  .monitoring .text-wrapper-2 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .monitoring .overlap-wrapper {
    height: 40px;
    left: 924px;
    position: absolute;
    top: 118px;
    width: 402px;
  }
  
  .monitoring .overlap-2 {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: inset 0px 0px 10px 1px #0000000d, 0px 0px 4px 2px #0000000d;
    height: 552px;
    left: 491px;
    position: absolute;
    top: 188px;
    width: 1365px;
  }
  
  .monitoring .text-wrapper-3 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 78px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-4 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 978px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-5 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 1158px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-6 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 798px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-7 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 618px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-8 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 438px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-9 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 258px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 435px;
    white-space: nowrap;
  }
  
  .monitoring .overlap-3 {
    height: 366px;
    left: 55px;
    position: absolute;
    top: 60px;
    width: 1241px;
  }
  
  .monitoring .line {
    height: 1px;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 366px;
    width: 1241px;
  }
  
  .monitoring .group {
    height: 326px;
    left: 46px;
    position: absolute;
    top: 40px;
    width: 71px;
  }
  
  .monitoring .rectangle {
    background-color: #004a53;
    border-radius: 5px 5px 0px 0px;
    height: 326px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
  }
  
  .monitoring .rectangle-2 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 165px;
    left: 43px;
    position: absolute;
    top: 161px;
    width: 28px;
  }
  
  .monitoring .group-2 {
    height: 308px;
    left: 1121px;
    position: absolute;
    top: 58px;
    width: 72px;
  }
  
  .monitoring .rectangle-3 {
    background-color: #004a53;
    border-radius: 5px 5px 0px 0px;
    height: 308px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
  }
  
  .monitoring .rectangle-4 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 210px;
    left: 44px;
    position: absolute;
    top: 98px;
    width: 28px;
  }
  
  .monitoring .group-3 {
    height: 366px;
    left: 940px;
    position: absolute;
    top: 0;
    width: 72px;
  }
  
  .monitoring .rectangle-5 {
    background-color: #004a53;
    border-radius: 5px 5px 0px 0px;
    height: 366px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
  }
  
  .monitoring .rectangle-6 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 240px;
    left: 44px;
    position: absolute;
    top: 126px;
    width: 28px;
  }
  
  .monitoring .group-4 {
    height: 340px;
    left: 761px;
    position: absolute;
    top: 26px;
    width: 72px;
  }
  
  .monitoring .rectangle-7 {
    background-color: #004a53;
    border-radius: 5px 5px 0px 0px;
    height: 340px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
  }
  
  .monitoring .rectangle-8 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 340px;
    left: 44px;
    position: absolute;
    top: 0;
    width: 28px;
  }
  
  .monitoring .group-5 {
    height: 340px;
    left: 582px;
    position: absolute;
    top: 26px;
    width: 72px;
  }
  
  .monitoring .rectangle-9 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 210px;
    left: 44px;
    position: absolute;
    top: 130px;
    width: 28px;
  }
  
  .monitoring .group-6 {
    height: 280px;
    left: 403px;
    position: absolute;
    top: 86px;
    width: 72px;
  }
  
  .monitoring .rectangle-10 {
    background-color: #004a53;
    border-radius: 5px 5px 0px 0px;
    height: 280px;
    left: 0;
    position: absolute;
    top: 0;
    width: 29px;
  }
  
  .monitoring .rectangle-11 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 180px;
    left: 44px;
    position: absolute;
    top: 100px;
    width: 28px;
  }
  
  .monitoring .group-7 {
    height: 326px;
    left: 225px;
    position: absolute;
    top: 40px;
    width: 71px;
  }
  
  .monitoring .rectangle-12 {
    background-color: #0caebf;
    border-radius: 5px 5px 0px 0px;
    height: 140px;
    left: 43px;
    position: absolute;
    top: 186px;
    width: 28px;
  }
  
  .monitoring .rectangle-13 {
    background-color: #004a53;
    height: 27px;
    left: 542px;
    position: absolute;
    top: 487px;
    width: 27px;
  }
  
  .monitoring .img {
    height: 25px;
    left: 713px;
    position: absolute;
    top: 487px;
    width: 25px;
  }
  
  .monitoring .text-wrapper-10 {
    color: #069dae;
    font-family: "Red Hat Display-SemiBold", Helvetica;
    font-size: 18px;
    font-weight: 600;
    left: 748px;
    letter-spacing: 0.72px;
    line-height: normal;
    position: absolute;
    top: 487px;
  }
  
  .monitoring .text-wrapper-11 {
    color: #004a53;
    font-family: "Red Hat Display-SemiBold", Helvetica;
    font-size: 18px;
    font-weight: 600;
    left: 579px;
    letter-spacing: 0.72px;
    line-height: normal;
    position: absolute;
    text-shadow: 0px 4px 4px #00000040;
    top: 487px;
  }
  
  .monitoring .overlap-4 {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: inset 0px 0px 10px 1px #0000000d, 0px 0px 4px 2px #0000000d;
    height: 293px;
    left: 491px;
    position: absolute;
    top: 762px;
    width: 1365px;
  }
  
  .monitoring .text-wrapper-12 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 78px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-13 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 978px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-14 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 1158px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-15 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 798px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-16 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 618px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-17 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 438px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-18 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 258px;
    letter-spacing: 0.4px;
    line-height: normal;
    position: absolute;
    top: 252px;
    white-space: nowrap;
  }
  
  .monitoring .line-2 {
    height: 1px;
    left: 55px;
    object-fit: cover;
    position: absolute;
    top: 238px;
    width: 1241px;
  }
  
  .monitoring .line-3 {
    height: 1px;
    left: 55px;
    object-fit: cover;
    position: absolute;
    top: 188px;
    width: 1241px;
  }
  
  .monitoring .overlap-5 {
    height: 148px;
    left: 37px;
    position: absolute;
    top: 23px;
    width: 1259px;
  }
  
  .monitoring .overlap-6 {
    height: 142px;
    left: 18px;
    position: absolute;
    top: 6px;
    width: 1241px;
  }
  
  .monitoring .line-4 {
    height: 1px;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 108px;
    width: 1241px;
  }
  
  .monitoring .line-5 {
    height: 1px;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 58px;
    width: 1241px;
  }
  
  .monitoring .line-6 {
    height: 1px;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 8px;
    width: 1241px;
  }
  
  .monitoring .vector {
    height: 125px;
    left: 71px;
    position: absolute;
    top: 16px;
    width: 1102px;
  }
  
  .monitoring .vector-2 {
    height: 64px;
    left: 69px;
    position: absolute;
    top: 0;
    width: 1104px;
  }
  
  .monitoring .text-wrapper-19 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 12px;
    font-weight: 400;
    left: 0;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 100px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-20 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 12px;
    font-weight: 400;
    left: 0;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 50px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-21 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 12px;
    font-weight: 400;
    left: 0;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 0;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-22 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 12px;
    font-weight: 400;
    left: 37px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 173px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-23 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 12px;
    font-weight: 400;
    left: 37px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 211px;
    white-space: nowrap;
  }
  
  .monitoring .overlap-group-wrapper {
    height: 200px;
    left: 64px;
    position: absolute;
    top: 183px;
    width: 404px;
  }
  
  .monitoring .overlap-7 {
    background-color: #ffffff;
    border-radius: 30px;
    box-shadow: 0px 0px 4px 4px #0000000d;
    height: 200px;
    position: relative;
    width: 400px;
  }
  
  .monitoring .h-1 {
    color: #000000;
    font-family: "Roboto-Bold", Helvetica;
    font-size: 64px;
    font-weight: 700;
    left: 142px;
    letter-spacing: 2.56px;
    line-height: normal;
    position: absolute;
    top: 92px;
    white-space: nowrap;
  }
  
  .monitoring .total-store {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 32px;
    font-weight: 700;
    left: 107px;
    letter-spacing: 1.28px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .monitoring .div-wrapper {
    height: 200px;
    left: 64px;
    position: absolute;
    top: 407px;
    width: 406px;
  }
  
  .monitoring .text-wrapper-24 {
    color: #49bc92;
    font-family: "Roboto-Bold", Helvetica;
    font-size: 64px;
    font-weight: 700;
    left: 92px;
    letter-spacing: 2.56px;
    line-height: normal;
    position: absolute;
    top: 92px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-25 {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 32px;
    font-weight: 700;
    left: 61px;
    letter-spacing: 1.28px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .monitoring .text-wrapper-26 {
    color: #9f9696;
    font-family: "Roboto-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 218px;
    letter-spacing: 0.96px;
    line-height: normal;
    position: absolute;
    top: 129px;
    white-space: nowrap;
  }
  
  .monitoring .group-8 {
    height: 200px;
    left: 64px;
    position: absolute;
    top: 631px;
    width: 406px;
  }
  
  .monitoring .text-wrapper-27 {
    color: #004a53;
    font-family: "Roboto-Bold", Helvetica;
    font-size: 64px;
    font-weight: 700;
    left: 92px;
    letter-spacing: 2.56px;
    line-height: normal;
    position: absolute;
    text-align: right;
    top: 92px;
    white-space: nowrap;
  }
  
  .monitoring .text-wrapper-28 {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 32px;
    font-weight: 700;
    left: 49px;
    letter-spacing: 1.28px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 33px;
  }
  `, "",{"version":3,"sources":["webpack://./src/style/tabel.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yDAAmD;IACnD,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uEAAuE;IACvE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uEAAuE;IACvE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX","sourcesContent":[".monitoring {\n    background-color: #ebf3f8;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .monitoring .div {\n    background-color: #ebf3f8;\n    border: 1px none;\n    height: 1080px;\n    overflow: hidden;\n    position: relative;\n    width: 1920px;\n  }\n  \n  .monitoring .overlap {\n    background-color: #ffffff;\n    border: 1px solid;\n    border-color: #d9d9d9;\n    height: 102px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 1922px;\n  }\n  \n  .monitoring .header-DATA {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 144px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .monitoring .logo-SIVINA {\n    background-image: url(../assets/images/bg/logo.png);\n    background-size: 100% 100%;\n    height: 60px;\n    left: 64px;\n    position: absolute;\n    top: 20px;\n    width: 60px;\n  }\n  \n  .monitoring .action-project {\n    color: #000000;\n    font-family: \"Montserrat-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 1329px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .monitoring .action-dashboard {\n    color: #000000;\n    font-family: \"Montserrat-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 1650px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .monitoring .profile-icon {\n    background-color: #49bc92;\n    border-radius: 25px;\n    height: 50px;\n    left: 1840px;\n    position: absolute;\n    top: 25px;\n    width: 50px;\n  }\n  \n  .monitoring .s {\n    height: 18px;\n    left: 19px;\n    position: absolute;\n    top: 16px;\n    width: 13px;\n  }\n  \n  .monitoring .action-filter-store {\n    height: 40px;\n    left: 64px;\n    position: absolute;\n    top: 118px;\n    width: 402px;\n  }\n  \n  .monitoring .overlap-group {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 400px;\n  }\n  \n  .monitoring .polygon {\n    height: 13px;\n    left: 369px;\n    position: absolute;\n    top: 10px;\n    width: 15px;\n  }\n  \n  .monitoring .MSRA {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper {\n    letter-spacing: 0;\n  }\n  \n  .monitoring .span {\n    letter-spacing: 0.4px;\n  }\n  \n  .monitoring .action-filter-lain {\n    height: 40px;\n    left: 494px;\n    position: absolute;\n    top: 118px;\n    width: 402px;\n  }\n  \n  .monitoring .text-wrapper-2 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .overlap-wrapper {\n    height: 40px;\n    left: 924px;\n    position: absolute;\n    top: 118px;\n    width: 402px;\n  }\n  \n  .monitoring .overlap-2 {\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: inset 0px 0px 10px 1px #0000000d, 0px 0px 4px 2px #0000000d;\n    height: 552px;\n    left: 491px;\n    position: absolute;\n    top: 188px;\n    width: 1365px;\n  }\n  \n  .monitoring .text-wrapper-3 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 78px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-4 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 978px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-5 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 1158px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-6 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 798px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-7 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 618px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-8 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 438px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-9 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 258px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 435px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .overlap-3 {\n    height: 366px;\n    left: 55px;\n    position: absolute;\n    top: 60px;\n    width: 1241px;\n  }\n  \n  .monitoring .line {\n    height: 1px;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 366px;\n    width: 1241px;\n  }\n  \n  .monitoring .group {\n    height: 326px;\n    left: 46px;\n    position: absolute;\n    top: 40px;\n    width: 71px;\n  }\n  \n  .monitoring .rectangle {\n    background-color: #004a53;\n    border-radius: 5px 5px 0px 0px;\n    height: 326px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 28px;\n  }\n  \n  .monitoring .rectangle-2 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 165px;\n    left: 43px;\n    position: absolute;\n    top: 161px;\n    width: 28px;\n  }\n  \n  .monitoring .group-2 {\n    height: 308px;\n    left: 1121px;\n    position: absolute;\n    top: 58px;\n    width: 72px;\n  }\n  \n  .monitoring .rectangle-3 {\n    background-color: #004a53;\n    border-radius: 5px 5px 0px 0px;\n    height: 308px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 28px;\n  }\n  \n  .monitoring .rectangle-4 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 210px;\n    left: 44px;\n    position: absolute;\n    top: 98px;\n    width: 28px;\n  }\n  \n  .monitoring .group-3 {\n    height: 366px;\n    left: 940px;\n    position: absolute;\n    top: 0;\n    width: 72px;\n  }\n  \n  .monitoring .rectangle-5 {\n    background-color: #004a53;\n    border-radius: 5px 5px 0px 0px;\n    height: 366px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 28px;\n  }\n  \n  .monitoring .rectangle-6 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 240px;\n    left: 44px;\n    position: absolute;\n    top: 126px;\n    width: 28px;\n  }\n  \n  .monitoring .group-4 {\n    height: 340px;\n    left: 761px;\n    position: absolute;\n    top: 26px;\n    width: 72px;\n  }\n  \n  .monitoring .rectangle-7 {\n    background-color: #004a53;\n    border-radius: 5px 5px 0px 0px;\n    height: 340px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 28px;\n  }\n  \n  .monitoring .rectangle-8 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 340px;\n    left: 44px;\n    position: absolute;\n    top: 0;\n    width: 28px;\n  }\n  \n  .monitoring .group-5 {\n    height: 340px;\n    left: 582px;\n    position: absolute;\n    top: 26px;\n    width: 72px;\n  }\n  \n  .monitoring .rectangle-9 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 210px;\n    left: 44px;\n    position: absolute;\n    top: 130px;\n    width: 28px;\n  }\n  \n  .monitoring .group-6 {\n    height: 280px;\n    left: 403px;\n    position: absolute;\n    top: 86px;\n    width: 72px;\n  }\n  \n  .monitoring .rectangle-10 {\n    background-color: #004a53;\n    border-radius: 5px 5px 0px 0px;\n    height: 280px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 29px;\n  }\n  \n  .monitoring .rectangle-11 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 180px;\n    left: 44px;\n    position: absolute;\n    top: 100px;\n    width: 28px;\n  }\n  \n  .monitoring .group-7 {\n    height: 326px;\n    left: 225px;\n    position: absolute;\n    top: 40px;\n    width: 71px;\n  }\n  \n  .monitoring .rectangle-12 {\n    background-color: #0caebf;\n    border-radius: 5px 5px 0px 0px;\n    height: 140px;\n    left: 43px;\n    position: absolute;\n    top: 186px;\n    width: 28px;\n  }\n  \n  .monitoring .rectangle-13 {\n    background-color: #004a53;\n    height: 27px;\n    left: 542px;\n    position: absolute;\n    top: 487px;\n    width: 27px;\n  }\n  \n  .monitoring .img {\n    height: 25px;\n    left: 713px;\n    position: absolute;\n    top: 487px;\n    width: 25px;\n  }\n  \n  .monitoring .text-wrapper-10 {\n    color: #069dae;\n    font-family: \"Red Hat Display-SemiBold\", Helvetica;\n    font-size: 18px;\n    font-weight: 600;\n    left: 748px;\n    letter-spacing: 0.72px;\n    line-height: normal;\n    position: absolute;\n    top: 487px;\n  }\n  \n  .monitoring .text-wrapper-11 {\n    color: #004a53;\n    font-family: \"Red Hat Display-SemiBold\", Helvetica;\n    font-size: 18px;\n    font-weight: 600;\n    left: 579px;\n    letter-spacing: 0.72px;\n    line-height: normal;\n    position: absolute;\n    text-shadow: 0px 4px 4px #00000040;\n    top: 487px;\n  }\n  \n  .monitoring .overlap-4 {\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: inset 0px 0px 10px 1px #0000000d, 0px 0px 4px 2px #0000000d;\n    height: 293px;\n    left: 491px;\n    position: absolute;\n    top: 762px;\n    width: 1365px;\n  }\n  \n  .monitoring .text-wrapper-12 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 78px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-13 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 978px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-14 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 1158px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-15 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 798px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-16 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 618px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-17 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 438px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-18 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 258px;\n    letter-spacing: 0.4px;\n    line-height: normal;\n    position: absolute;\n    top: 252px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .line-2 {\n    height: 1px;\n    left: 55px;\n    object-fit: cover;\n    position: absolute;\n    top: 238px;\n    width: 1241px;\n  }\n  \n  .monitoring .line-3 {\n    height: 1px;\n    left: 55px;\n    object-fit: cover;\n    position: absolute;\n    top: 188px;\n    width: 1241px;\n  }\n  \n  .monitoring .overlap-5 {\n    height: 148px;\n    left: 37px;\n    position: absolute;\n    top: 23px;\n    width: 1259px;\n  }\n  \n  .monitoring .overlap-6 {\n    height: 142px;\n    left: 18px;\n    position: absolute;\n    top: 6px;\n    width: 1241px;\n  }\n  \n  .monitoring .line-4 {\n    height: 1px;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 108px;\n    width: 1241px;\n  }\n  \n  .monitoring .line-5 {\n    height: 1px;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 58px;\n    width: 1241px;\n  }\n  \n  .monitoring .line-6 {\n    height: 1px;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 8px;\n    width: 1241px;\n  }\n  \n  .monitoring .vector {\n    height: 125px;\n    left: 71px;\n    position: absolute;\n    top: 16px;\n    width: 1102px;\n  }\n  \n  .monitoring .vector-2 {\n    height: 64px;\n    left: 69px;\n    position: absolute;\n    top: 0;\n    width: 1104px;\n  }\n  \n  .monitoring .text-wrapper-19 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 12px;\n    font-weight: 400;\n    left: 0;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 100px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-20 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 12px;\n    font-weight: 400;\n    left: 0;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 50px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-21 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 12px;\n    font-weight: 400;\n    left: 0;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 0;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-22 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 12px;\n    font-weight: 400;\n    left: 37px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 173px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-23 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 12px;\n    font-weight: 400;\n    left: 37px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 211px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .overlap-group-wrapper {\n    height: 200px;\n    left: 64px;\n    position: absolute;\n    top: 183px;\n    width: 404px;\n  }\n  \n  .monitoring .overlap-7 {\n    background-color: #ffffff;\n    border-radius: 30px;\n    box-shadow: 0px 0px 4px 4px #0000000d;\n    height: 200px;\n    position: relative;\n    width: 400px;\n  }\n  \n  .monitoring .h-1 {\n    color: #000000;\n    font-family: \"Roboto-Bold\", Helvetica;\n    font-size: 64px;\n    font-weight: 700;\n    left: 142px;\n    letter-spacing: 2.56px;\n    line-height: normal;\n    position: absolute;\n    top: 92px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .total-store {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 32px;\n    font-weight: 700;\n    left: 107px;\n    letter-spacing: 1.28px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .monitoring .div-wrapper {\n    height: 200px;\n    left: 64px;\n    position: absolute;\n    top: 407px;\n    width: 406px;\n  }\n  \n  .monitoring .text-wrapper-24 {\n    color: #49bc92;\n    font-family: \"Roboto-Bold\", Helvetica;\n    font-size: 64px;\n    font-weight: 700;\n    left: 92px;\n    letter-spacing: 2.56px;\n    line-height: normal;\n    position: absolute;\n    top: 92px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-25 {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 32px;\n    font-weight: 700;\n    left: 61px;\n    letter-spacing: 1.28px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .monitoring .text-wrapper-26 {\n    color: #9f9696;\n    font-family: \"Roboto-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 218px;\n    letter-spacing: 0.96px;\n    line-height: normal;\n    position: absolute;\n    top: 129px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .group-8 {\n    height: 200px;\n    left: 64px;\n    position: absolute;\n    top: 631px;\n    width: 406px;\n  }\n  \n  .monitoring .text-wrapper-27 {\n    color: #004a53;\n    font-family: \"Roboto-Bold\", Helvetica;\n    font-size: 64px;\n    font-weight: 700;\n    left: 92px;\n    letter-spacing: 2.56px;\n    line-height: normal;\n    position: absolute;\n    text-align: right;\n    top: 92px;\n    white-space: nowrap;\n  }\n  \n  .monitoring .text-wrapper-28 {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 32px;\n    font-weight: 700;\n    left: 49px;\n    letter-spacing: 1.28px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 33px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
